import { Link } from "react-router-dom";
import useCategories from "../hooks/useCategories";
import Layout from "../components/Layout/Layout";

const Categories = () => {
  const categories = useCategories();
  return (
    <Layout title="All Categories">
      <div className="container">
        <div className="row">
          {categories.map((c) => (
            <div className="col-md-6 mt-5 mb-3 gx-3 gy-3" key={c._id}>
              <Link to={`/category/${c.slug}`} className="btn btn-primary">
                {c.name}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Categories;
